/**
 * Path helpers for the ETF marketing site. Adapted from the dane
 * etf-website `lib/fund-paths.ts` + `lib/fund-categories.ts` to plain
 * react-router paths (no `/etf-website` prefix, no dual-host logic).
 *
 * Category landing routes (match the dane route paths):
 *   thematic  → /thematic
 *   leveraged → /2xleveraged
 *   buffer    → /buffered
 */
const CATEGORY_PATH_SEGMENT: Record<string, string> = {
  thematic: "thematic",
  leveraged: "2xleveraged",
  buffer: "buffered",
};

export function categoryListingPath(type: string): string {
  const seg = CATEGORY_PATH_SEGMENT[type];
  return seg ? `/${seg}` : "/products";
}

export function fundDetailPath(slug: string): string {
  return `/${slug}`;
}

export function blogPostPath(slug: string): string {
  return `/blog/${slug}`;
}
